import React from "react";

const FurtherLinksCard = ({
  title,
  url,
  description,
  domainName,
  favicon,
  className = "",
}) => {
  return (
    <div
      className={`card bg-transparent comic-box py-2 px-4 py-md-4 px-lg-5 border-0 h-100 ${className}`}>
      <div className="card-body d-flex flex-column">
        {/* Header avec favicon et domaine */}
        <div className="d-flex align-items-center mb-2">
          {favicon && (
            <img
              src={favicon}
              alt={`${domainName} favicon`}
              className="me-2"
              style={{ width: "16px", height: "16px" }}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          )}
          <small className="text-muted">{domainName}</small>
        </div>

        {/* Titre */}
        <h6 className="card-title mb-2" style={{ letterSpacing: "0.025em" }}>
          <a
            href={url}
            className="text-decoration-none text-dark stretched-link"
            target="_blank"
            rel="noopener noreferrer"
            title={title}>
            {title}
          </a>
        </h6>

        {/* Description (si elle existe) */}
        {description && (
          <p
            className="card-text text-muted flex-grow-1"
            style={{
              fontSize: "0.75rem",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}>
            {description}
          </p>
        )}

        {/* Footer avec l'URL raccourcie */}
        <div className="mt-auto">
          <small
            className="text-primary"
            style={{
              fontSize: "0.75rem",
              display: "-webkit-box",
              WebkitLineClamp: 1,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}>
            {url.length > 164 ? `${url.substring(0, 164)}...` : url}
          </small>
        </div>
      </div>
    </div>
  );
};

export default FurtherLinksCard;
